export const SUPPORTED_AND_DEPRECATED_LOCALES = [
  'de',
  'en',
  'es',
  'fr',
  'it',
] as const;
export const VISIBLE_LOCALES = ['de', 'en'] as const;
export const DEPRECATED_LOCALES = ['es', 'fr', 'it'] as const;

export type Locale = (typeof SUPPORTED_AND_DEPRECATED_LOCALES)[number];
